import { BasicSelect, MultiSelect } from 'vue-search-select'
import CryptoJS from 'crypto-js'
import Pagination from './../../../../shared/components/pagination'
import Loader from '../../../../shared/components/loader'
import CONSTANT from '../../../../shared/constants/constant'
import Util from '../../../../shared/util/util'
import Treeselect from '@riophae/vue-treeselect'
import TripServices from '../../../services/firstAndLastmilemanagement.service'
import ClientService from '../../../../clientmanagement/services/clientmanagement.service';
import {Validator} from 'vee-validate';
import Multiselect from 'vue-multiselect'
const moment = require('moment')

export default {
  name: 'CreateBulkdeliveryconfig',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    Loader,
    Multiselect
  },
  props: ['parentObj'],
  data: function () {
    return {
      createFTCCashDeposit: false,
      isLoading: false,
      companyNamelist: [],
      selectedHub:null,
      selectedhub: null,
      hublist: [],
      AWB: "",
      Action: "",
      useremail: "",
      Consigneelist:[],
      selectedConsignee: { value: "", text: "", clientid:"" },
      selectedconsignee: {},
      pincode: null,
      minmps: null,
      hubnameerror: false,
      hubErr:'',
      pincodeerr : '',
      clientErr:'',
      mpsErr: '',
      pincodesuccesmsg : '',
      savedisableflag : true
    };
  },
  created() {
    this.$root.$refs.CreateBulkdeliveryconfig = this;
  },
  computed: {},
  async mounted () {
    this.hublist = this.parentObj.hublist;
    this.Clientlist = this.parentObj.clientlist;
    this.useremail = this.parentObj.useremail;
    if (this.parentObj.action == 'update') {
      this.isLoading = true
      this.pincode = this.parentObj.data.pincode
      this.selectedHub={
        value: this.parentObj.data.hubid,
        text: this.parentObj.data.hubname
      }
      this.minmps = this.parentObj.data.minmps;
      this.selectedConsignee.value = this.parentObj.data.consigneecode
      this.selectedConsignee.text = this.parentObj.data.consigneename
      let input = {
        pincode : this.parentObj.data.pincode
      }
      this.savedisableflag = false
      let getconsigneelist = await TripServices.getConsigneename(input)
      if(getconsigneelist.data.code == 200) {
        getconsigneelist.data.data.forEach(el=>{
          this.Consigneelist.push({
            "text" : el.consigneename,
            "value" : el.consigneecode,
            "clientid":el.clientid
          })
        })
      }
      else {
        this.$alert(getconsigneelist.data.message, "", "error");
      }
      this.isLoading = false;
    }
  },
  methods: {
    selectHub(data){
      this.selectedHub = data;
      if(this.pincode!=null){
        this.validatepincodehub()
      }
    },
    selectConsignee(data){
      this.selectedConsignee = data;
    },

    async create() {
      this.isLoading = true;
      if(this.checkErr()){
        this.isLoading = false;
        return false;
      }
      let input ={
        consigneecode: this.selectedConsignee.value,
        consigneename: this.selectedConsignee.text,
        clientid: this.selectedConsignee.clientid,
        minmps: this.minmps,
        lastmodifiedby: this.useremail,
        action: this.parentObj.action,
        pincode : this.pincode
      }
      if (this.selectedHub) {
        input.hubid = this.selectedHub.value,
        input. hubname= this.selectedHub.text
      }
      if (this.parentObj.action == 'update') {
        input.configid = this.parentObj.data.id
      }

      let result = await TripServices.saveBulkDeliveryConfig(input);
      console.log("result",result);
      if (result.data.code == 200) {
        let message = this.parentObj.action == 'update' ? "Updated Successfully": "Created Successfully";
        this.$alert(message, "", "success");
        this.showBulkConfigurationList();
      } else{
        this.$alert(result.data.message, "", "error");
      }
      this.isLoading = false;
    },
    showBulkConfigurationList() {
      this.$emit("goBackToParent")
    },
    checkErr(){
      let err = 0
      if(!this.selectedHub){
        this.hubErr = 'Please Select Hub'
        err = 1
      }else{
        this.hubErr = ''
      }
      if(this.selectedConsignee.value == ""){
        this.clientErr = 'Please Select Consignee Name'
        err = 1
      } else {
        this.clientErr ='';
      }
      if (!this.minmps) {
        this.mpsErr = 'Please Enter Minimum MPS count'
        err = 1
      } else {
        this.mpsErr = '';
      }
      return err
    },
    async validatepincodehub() {
      this.isLoading = true;
      if(this.checkhubmappingerr()) {
        this.isLoading = false;
        return false;
      }
      let input = {
        pincode : this.pincode
      }
      if (this.selectedHub) {
        input.hubid = this.selectedHub.value
      }
      this.Consigneelist = []
      let checkhubmapping = await TripServices.checkHubMapping(input)
      if(checkhubmapping.data.code == 200) {
        let input1 = {
          pincode : this.pincode
        }
        let getconsigneelist = await TripServices.getConsigneename(input1)
        if(getconsigneelist.data.code == 200) {
          this.savedisableflag = false
          getconsigneelist.data.data.forEach(el=>{
            this.Consigneelist.push({
              "text" : el.consigneename,
              "value" : el.consigneecode,
              "clientid":el.clientid
            })
          })
        }
        else {
          this.pincodesuccesmsg = ''
          this.$alert(getconsigneelist.data.message, "", "error");
        }
        this.pincodesuccesmsg = 'Pincode Mapped to the selected hub'
        this.isLoading = false;
      }
      else {
        this.savedisableflag = true
        this.pincodesuccesmsg = ''
        this.$alert(checkhubmapping.data.message, "", "error");
      }
      this.isLoading = false;
    },
    checkhubmappingerr(){
      let err = 0
      if(!this.selectedHub){
        this.hubErr = 'Please Select Hub'
        err = 1
      }else{
        this.hubErr = ''
      }
      if(this.pincode == ""){
        this.pincodeerr = 'Please Enter Pincode'
        err = 1
        this.savedisableflag = true
      } else {
        this.pincodeerr ='';
      }
      if (this.pincode.length != 6) {
        // console.log("");
        this.pincodeerr = 'Please enter a valid pincode (6 digits)'
        this.pincodesuccesmsg = ''
        this.savedisableflag = true
        err = 1
      } else {
        this.pincodeerr = '';
      }
      return err
    },

  },
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/bulkdelivery/CreateBulkdeliveryconfig/CreateBulkdeliveryconfig.component.js